module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "modern-ui",
    attrs: {
      "name": "what-friends-see"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('f7-link', {
    staticClass: "mui-button accent-50",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.625 12.5L3.125 8L7.625 3.5M3.75 8H12.875",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" Back")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n            Referral History\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("You’re sharing your personal referral page - not just a link")]), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_c('ul', {
    staticClass: "options"
  }, [_c('li', [_c('check-rounded-icon'), _vm._v("A personal introduction to [sales name]\n                ")], 1), _vm._v(" "), _c('li', [_c('check-rounded-icon'), _vm._v("A personal intro from you\n                ")], 1), _vm._v(" "), _c('li', [_c('check-rounded-icon'), _vm._v("Easy ways for your friend to start shopping\n                ")], 1), _vm._v(" "), _c('li', [_c('check-rounded-icon'), _vm._v("Referral activity is tracked for you\n                ")], 1)])]), _vm._v(" "), _c('f7-link', {
    staticClass: "mui-button w-100 accent",
    attrs: {
      "href": _vm.addReferralUrl
    }
  }, [_c('send-icon'), _vm._v("\n            Share your referral page\n        ")], 1), _vm._v(" "), _c('h2', {
    staticClass: "preview-title"
  }, [_vm._v("Here is how page look like")]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [(_vm.previewUrl) ? _c('iframe', {
    attrs: {
      "src": _vm.previewUrl,
      "frameborder": "0"
    },
    on: {
      "load": function($event) {
        return _vm.iframeLoaded()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.previewReady) ? _c('loader', {
    staticClass: "preview-loader",
    attrs: {
      "show": true,
      "global": false
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.previewUrl) ? _c('f7-link', {
    staticClass: "mui-button w-100 accent-fg",
    attrs: {
      "external": "",
      "href": _vm.previewUrl,
      "target": "_blank"
    }
  }, [_c('external-link-icon'), _vm._v("\n            Preview my referral page")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.loading) ? _c('loader', {
    attrs: {
      "show": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1bdf364", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1bdf364"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/referral-program/what-friends-see.vue
// module id = 875
// module chunks = 0